module.exports = __webpack_public_path__ + "img/car_shina2_42.25f3fdd0.jpg";